import { Firestore } from "../lib/firebase";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

toast.configure({
  autoClose: 2000,
  draggable: false
});

const EMPLOYEES_TABLE_NAME = "employees";

export function getEmployees(country) {
  let ref = Firestore.collection(EMPLOYEES_TABLE_NAME);
  if (country) {
    ref = ref.where("country", "==", country);
  }

  return ref
    .get()
    .then((result) => {
      const employees = [];
      for (const doc of result.docs) {
        const employee = doc.data();
        employee.id = doc.id;

        employees.push(employee);
      }

      return employees;
    })
    .catch((error) => error);
}

export function createEmployee(payload) {
  return Firestore.collection(EMPLOYEES_TABLE_NAME)
    .doc()
    .set(payload, { merge: true })
    .catch((error) => error);
}


export async function getEmployee(employeeId) {
  const res = await Firestore.collection(EMPLOYEES_TABLE_NAME)
    .doc(employeeId)
    .get();
  return res ? res.data() : null;
}
export function deleteEmployeeById(id, setData,isDeleting,setIsDeleting) {

  if (isDeleting) {
    return;
  }

  setIsDeleting(true);

  const docRef = Firestore.collection(EMPLOYEES_TABLE_NAME).doc(id);

  docRef.delete()
    .then(() => {
      setData(prevData => prevData.filter(item => item.id !== id));
      toast.success("Employee deleted successfully!", {
        position: toast.POSITION.TOP_LEFT
      });
    })
    .catch((error) => {
      console.error("Error removing document: ", error);
    })
    .finally(() => {
      setIsDeleting(false);
    });
}
